// Path: ./src/utils/DetechFlyerItemCategory/index.ts
import { GfFlyerItemCategory } from "@swagger/typescript-fetch-goflyer";

/**
 * Function to normalize a string by converting it to lowercase,
 * replacing '&' with 'and', removing non-alphanumeric characters
 * except spaces, removing consecutive spaces, and replacing underscores with spaces.
 * @param str The string to be normalized
 * @returns The normalized string
 */
function normalizeString(str: string): string {
  let normalizedStr = str.toLowerCase();
  normalizedStr = normalizedStr.replace(/&/g, "and");
  normalizedStr = normalizedStr.replace(/_/g, " ");
  normalizedStr = normalizedStr.replace(/[^a-z0-9\s]/g, "");
  normalizedStr = normalizedStr.replace(/\s+/g, " ");
  return normalizedStr.trim();
}

/**
 * Function to detect categories present in the URL.
 * @param url The URL string to search for categories
 * @param categories An array of category strings to compare against the URL
 * @returns An array of matched categories
 */
function findMatchingCategories(url: string, categories: string[]): string[] {
  const normalizedUrl = normalizeString(url);

  const matchedCategories = categories.filter((category) => {
    const normalizedCategory = normalizeString(category);
    return (
      normalizedUrl.includes(normalizedCategory) ||
      normalizedCategory
        .split(" ")
        .every((word) => normalizedUrl.includes(word))
    );
  });

  return matchedCategories;
}

/**
 * Detect function to find categories from the URL.
 * @param url The URL to search for categories
 * @param flyerItemCategories An array of flyer item categories
 * @returns An array of matched flyer item categories
 */
export const detectCategoriesFromURL = (
  url: string,
  flyerItemCategories: GfFlyerItemCategory[]
) => {
  const categories = flyerItemCategories.map((val) => val.name);
  const found = findMatchingCategories(url, categories);
  if (found.length > 0) {
    return flyerItemCategories.filter((val) =>
      found.some((name) => name === val.name)
    );
  }
  return [];
};
